import { BaseService } from '@myhealth-raccoon/services';

import { TelehealthAvailableModel, TelehealthAvailableRequest } from './types';

class TelehealthService extends BaseService {
    constructor() {
        super('v1/telehealth', import.meta.env.VITE_BP_API_URL);
    }

    public async GetTelehealthAvailability(request: TelehealthAvailableRequest) {
        const query = new URLSearchParams(Object.entries(request).filter(([_, v]) => (v ?? false) !== false));
        return this.get<TelehealthAvailableModel[]>(`availability?${query}`);
    }
}

export const telehealthService = new TelehealthService();
export * from './types';
